import React, { useEffect, useState, useContext, useMemo, useRef } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import { useNavigate } from "react-router-dom";
import FareRule from "./FareRule";
import { AuthContext } from "../../Routes/AuthProvider"

const ResultHtml = ({ data, adult, child, infant, requestBody, flights, loading, error, handleBookNow, fareType }) => {

  const [loadingFlightIndex, setLoadingFlightIndex] = useState(null);
  const [selectedFlight, setSelectedFlight] = useState(null);
  const [selectedFareIndex, setSelectedFareIndex] = useState(null);
  const [fareRuleIndex, setFareRuleIndex] = useState(null);
  const { name, userName, roles, corporateId } = useContext(AuthContext);
  // const [sortType, setSortType] = useState("CHEAPEST");
  const [sortType, setSortType] = useState("DEPARTURE");
  const [loadFareRule, setLoadFareRule] = useState(false);
  const [loadFareRuleTab, setLoadFareRuleTab] = useState(false);
  // SORTING (CHEAPEST ON TOP BY DEFAULT)

  const [selectedFareMap, setSelectedFareMap] = useState({});

  const sortedFlights = useMemo(() => {
    if (!flights || flights.length === 0) return [];

    const copied = [...flights];
    ////console.log("copied FASTEST", copied);
    const getMinFare = (flight) => {
      if (flight.fares && flight.fares.length > 0) {
        return Math.min(...flight.fares.map(f => f.totalFare || 0));
      }
      return flight.fareDetails?.totalFare || 0;
    };

    const getDurationInMinutes = (duration) => {
      if (!duration) return 99999;
      const [h, m] = duration.split(":").map(Number);
      return h * 60 + m;
    };

    switch (sortType) {
      case "CHEAPEST":
        return copied.sort(
          (a, b) => getMinFare(a) - getMinFare(b)
        );

      case "FASTEST":
        return copied.sort(
          (a, b) =>
            getDurationInMinutes(a.totalDuration) -
            getDurationInMinutes(b.totalDuration)
        );

      case "NONSTOP":
        return copied.sort(
          (a, b) =>
            (a.segments?.length === 1 ? 0 : 1) -
            (b.segments?.length === 1 ? 0 : 1)
        );

      case "DEPARTURE":
        return copied.sort(
          (a, b) =>
            new Date(a.segments?.[0]?.departDateTime) -
            new Date(b.segments?.[0]?.departDateTime)
        );

      default:
        return copied;
    }
  }, [flights, sortType]);


  const ExportToExcel = () => {
    const excelData = flights.map((flight) => {
      const seg = flight.segments?.[0];
      const fare = flight.fares?.[0];

      return {
        // ItemNo: flight.itemNo,
        // Supplier: flight.supplierCode,
        // Source: flight.supSource,
        Airline: seg?.airLineName,
        AirlineCode: seg?.airLineCode,
        FlightNumber: seg?.flightNumber,
        From: seg?.departAirportCode,
        FromCity: seg?.departCityName,
        FromAirport: seg?.departAirportName,
        DepartTerminal: seg?.departTerminal,
        DepartureTime: seg?.departDateTime?.split("T")[1],
        To: seg?.arrivalAirportCode,
        ToCity: seg?.arrivalCityName,
        ToAirport: seg?.arrivalAirportName,
        ArrivalTerminal: seg?.arrivalTerminal,
        ArrivalTime: seg?.arrivalDateTime?.split("T")[1],
        Duration: seg?.duration,
        TotalDuration: flight.totalDuration,
        Stops: flight.stops,
        AvailableSeats: seg?.availableSeats,
        Equipment: seg?.equipmentType,
        BaseFare: fare?.totalBaseFare,
        OtherTax: fare?.totalOtherTax,
        TotalFare: fare?.totalFare,
        NetAmount: fare?.netAmount,
        Refundable: fare?.isRefundable ? "Yes" : "No",
        FareType: fare?.fareType
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Flights");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    saveAs(data, "FlightList.xlsx");
  };

  // -------------------------
  // Helper Functions
  // -------------------------
  const formatTime = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };
  const navigate = useNavigate();
  const calcDuration = (start, end) => {
    if (!start || !end) return "—";
    const s = new Date(start);
    const e = new Date(end);
    const diff = Math.abs(e - s) / 1000 / 60;
    const h = Math.floor(diff / 60);
    const m = diff % 60;
    return `${h}h ${m}m`;
  };

  // -------------------------
  // Button Handlers

  const [selectedFare, setSelectedFare] = useState(null);


  const handleViewMoreFare = (flight) => {
    if (!flight) return;

    //console.log("View More Fare", flight);
    setSelectedFlight(flight);
    setSelectedFare(null);

    setTimeout(() => {
      const offcanvas = document.getElementById("ViewMoreFare");
      if (offcanvas) {
        const bsOffcanvas = new window.bootstrap.Offcanvas(offcanvas);
        bsOffcanvas.show();
      }
    }, 50); // wait for React to update state
  };
  const formatDateForDisplay = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const [activeTab, setActiveTab] = useState("info");
  const [showAdSelct, setshowAdSelct] = useState(false);
  const [selectedShareFlights, setSelectedShareFlights] = useState([]);
  const [removedShareFares, setRemovedShareFares] = useState([]);

  const generateShareHTML = () => { let html = ` <div style=" font-family: Arial, Helvetica, sans-serif; margin: 20px 0; color: #333; background: #fff; "> <h2 style=" margin: 0 0 20px 0; color: #110942; font-size: 22px; font-weight: 600; "> Selected Flight Details </h2> <table style=" width: 100%; border-collapse: collapse; margin-bottom: 25px; font-family: Arial, Helvetica, sans-serif; "> <thead> <tr> <th style=" border: 1px solid #ddd; padding: 10px; text-align: center; vertical-align: middle; background: #110942; color: #fff; font-weight: 600; "> Flight Name </th> <th style=" border: 1px solid #ddd; padding: 10px; text-align: center; vertical-align: middle; background: #110942; color: #fff; font-weight: 600; "> Departure Time </th> <th style=" border: 1px solid #ddd; padding: 10px; text-align: center; vertical-align: middle; background: #110942; color: #fff; font-weight: 600; "> Arrival Time </th> <th style=" border: 1px solid #ddd; padding: 10px; text-align: center; vertical-align: middle; background: #110942; color: #fff; font-weight: 600; "> Duration </th> <th style=" border: 1px solid #ddd; padding: 10px; text-align: center; vertical-align: middle; background: #110942; color: #fff; font-weight: 600; "> Fares </th> </tr> </thead> <tbody> `; selectedShareFlights.forEach((selectedIndex) => { const flight = sortedFlights[selectedIndex]; if (!flight) { return; } const segments = flight.segments || []; const firstSegment = segments[0] || {}; const lastSegment = segments[segments.length - 1] || {}; let fareRows = ""; /* ========================= FARE ROWS ========================= */ if (flight.fares?.length > 0) { flight.fares.forEach((fare, fareIndex) => { const isRemoved = removedShareFares.some((item) => item.flightIndex === selectedIndex && item.fareIndex === fareIndex); if (isRemoved) { return; } const fareType = fare.journeyFareInfos?.[0]?.type || fare.fareName || fare.fareType || `Fare ${fareIndex + 1}`; const priceType = fare.journeyFareInfos?.[0]?.isRefundable ?? fare.isRefundable; let priceText = "-"; let priceStyle = ` color: #333; font-weight: 500; `; if (priceType === true) { priceText = "Refundable"; priceStyle = ` color: green; font-weight: 500; `; } if (priceType === false) { priceText = "Non Refundable"; priceStyle = ` color: red; font-weight: 500; `; } fareRows += ` <tr> <td style=" border: 1px solid #ddd; padding: 8px; text-align: center; vertical-align: middle; "> ${fareType} </td> <td style=" border: 1px solid #ddd; padding: 8px; text-align: center; vertical-align: middle; white-space: nowrap; "> ₹ ${Number(fare.totalFare || 0).toLocaleString("en-IN")} </td> <td style=" border: 1px solid #ddd; padding: 8px; text-align: center; vertical-align: middle; ${priceStyle} "> ${priceText} </td> </tr> `; }); } /* ========================= FLIGHT ROW ========================= */ html += ` <tr> <!-- Flight Name --> <td style=" border: 1px solid #ddd; padding: 10px; text-align: center; vertical-align: middle; font-weight: 600; "> ${firstSegment.airLineName || "Unknown Airline"} ${firstSegment.airLineCode || ""} - ${firstSegment.flightNumber || ""} </td> <!-- Departure --> <td style=" border: 1px solid #ddd; padding: 10px; text-align: center; vertical-align: middle; "> <strong> ${firstSegment.departDateTime ? formatTime(firstSegment.departDateTime) : "N/A"} </strong> <br> ${firstSegment.departCityName || ""} ${firstSegment.departAirportCode ? ` (${firstSegment.departAirportCode})` : ""} </td> <!-- Arrival --> <td style=" border: 1px solid #ddd; padding: 10px; text-align: center; vertical-align: middle; "> <strong> ${lastSegment.arrivalDateTime ? formatTime(lastSegment.arrivalDateTime) : "N/A"} </strong> <br> ${lastSegment.arrivalCityName || flight.arrivalCityName || ""} ${lastSegment.arrivalAirportCode ? ` (${lastSegment.arrivalAirportCode})` : ""} </td> <!-- Duration --> <td style=" border: 1px solid #ddd; padding: 10px; text-align: center; vertical-align: middle; white-space: nowrap; "> ${flight.totalDuration ? (() => { const [hours, minutes] = String(flight.totalDuration).split(":"); const h = parseInt(hours || 0, 10); const m = parseInt(minutes || 0, 10); return (`${h > 0 ? `${h}h ` : ""}` + `${m > 0 ? `${m}m` : ""}`).trim() || "N/A"; })() : firstSegment.duration || "N/A"} </td> <!-- Fares --> <td style=" border: 1px solid #ddd; padding: 5px; text-align: center; vertical-align: middle; "> ${fareRows ? ` <table style=" width: 100%; border-collapse: collapse; margin: 0; font-family: Arial, Helvetica, sans-serif; "> <thead> <tr> <th style=" border: 1px solid #ddd; padding: 7px; text-align: center; background: #f1f1f1; color: #333; font-weight: 600; "> Fare Type </th> <th style=" border: 1px solid #ddd; padding: 7px; text-align: center; background: #f1f1f1; color: #333; font-weight: 600; "> Amount </th> <th style=" border: 1px solid #ddd; padding: 7px; text-align: center; background: #f1f1f1; color: #333; font-weight: 600; "> Price Type </th> </tr> </thead> <tbody> ${fareRows} </tbody> </table> ` : ` <span style=" color: #777; font-size: 14px; "> Fare not available </span> `} </td> </tr> `; }); html += ` </tbody> </table> </div> `; return html; }; /* ========================= GENERATE PLAIN TEXT ========================= */ const generateSharePlainText = () => { let text = "Selected Flight Details\n\n"; selectedShareFlights.forEach((selectedIndex) => { const flight = sortedFlights[selectedIndex]; if (!flight) { return; } const segments = flight.segments || []; const firstSegment = segments[0] || {}; const lastSegment = segments[segments.length - 1] || {}; const duration = flight.totalDuration ? (() => { const [hours, minutes] = String(flight.totalDuration).split(":"); const h = parseInt(hours || 0, 10); const m = parseInt(minutes || 0, 10); return (`${h > 0 ? `${h}h ` : ""}` + `${m > 0 ? `${m}m` : ""}`).trim() || "N/A"; })() : firstSegment.duration || "N/A"; text += "----------------------------------------\n"; text += `${firstSegment.airLineName || "Unknown Airline"} ` + `${firstSegment.airLineCode || ""}-` + `${firstSegment.flightNumber || ""}\n`; text += `Departure: ${firstSegment.departDateTime ? formatTime(firstSegment.departDateTime) : "N/A"} ` + `${firstSegment.departCityName || ""}` + `${firstSegment.departAirportCode ? ` (${firstSegment.departAirportCode})` : ""}\n`; text += `Arrival: ${lastSegment.arrivalDateTime ? formatTime(lastSegment.arrivalDateTime) : "N/A"} ` + `${lastSegment.arrivalCityName || flight.arrivalCityName || ""}` + `${lastSegment.arrivalAirportCode ? ` (${lastSegment.arrivalAirportCode})` : ""}\n`; text += `Duration: ${duration}\n`; text += "\nFares:\n"; if (flight.fares?.length > 0) { flight.fares.forEach((fare, fareIndex) => { const isRemoved = removedShareFares.some((item) => item.flightIndex === selectedIndex && item.fareIndex === fareIndex); if (isRemoved) { return; } const fareType = fare.journeyFareInfos?.[0]?.type || fare.fareName || fare.fareType || `Fare ${fareIndex + 1}`; const priceType = fare.journeyFareInfos?.[0]?.isRefundable ?? fare.isRefundable; const priceText = priceType === true ? "Refundable" : priceType === false ? "Non Refundable" : "-"; text += ` ${fareType} | ₹ ${Number(fare.totalFare || 0).toLocaleString("en-IN")} | ${priceText}\n`; }); } else { text += " Fare not available\n"; } text += "\n"; }); return text; }; /* ========================= COPY RENDERED HTML ========================= */ const handleCopyHTML = async () => { try { if (!selectedShareFlights.length) { alert("Please select at least one flight."); return; } const html = generateShareHTML(); const plainText = generateSharePlainText(); /* ========================= CHECK CLIPBOARD SUPPORT ========================= */ if (!navigator.clipboard || typeof ClipboardItem === "undefined") { /* * Fallback for browsers that do not support * ClipboardItem. */ const tempDiv = document.createElement("div"); tempDiv.innerHTML = html; tempDiv.style.position = "fixed"; tempDiv.style.left = "-999999px"; tempDiv.style.top = "0"; document.body.appendChild(tempDiv); const range = document.createRange(); range.selectNodeContents(tempDiv); const selection = window.getSelection(); selection.removeAllRanges(); selection.addRange(range); const copied = document.execCommand("copy"); selection.removeAllRanges(); document.body.removeChild(tempDiv); if (!copied) { throw new Error("Browser does not support HTML clipboard copy."); } alert("Flight details copied successfully. You can paste them into email or chat."); return; } /* ========================= CREATE CLIPBOARD BLOBS ========================= */ const htmlBlob = new Blob([html], { type: "text/html", }); const textBlob = new Blob([plainText], { type: "text/plain", }); /* ========================= CREATE CLIPBOARD ITEM ========================= */ const clipboardItem = new ClipboardItem({ "text/html": htmlBlob, "text/plain": textBlob, }); /* ========================= WRITE TO CLIPBOARD ========================= */ await navigator.clipboard.write([clipboardItem,]); alert("Flight details copied successfully. You can paste them into email or chat."); } catch (error) { console.error("Copy Flight HTML Error:", error); alert("Unable to copy flight details. Please try again."); } };
  /* ========================= DOWNLOAD HTML ========================= */


  const handleDownloadExcel = () => {
    try {
      if (!selectedShareFlights.length) {
        alert("Please select at least one flight.");
        return;
      }

      const excelData = [];

      selectedShareFlights.forEach((selectedIndex) => {
        const flight = sortedFlights[selectedIndex];

        if (!flight) {
          return;
        }

        const segments = flight.segments || [];

        const firstSegment = segments[0] || {};

        const lastSegment =
          segments[segments.length - 1] || {};

        /* =========================
           DURATION
        ========================= */

        const duration = flight.totalDuration
          ? (() => {
            const [hours, minutes] =
              String(flight.totalDuration).split(":");

            const h = parseInt(hours || 0, 10);

            const m = parseInt(minutes || 0, 10);

            return (
              `${h > 0 ? `${h}h ` : ""}` +
              `${m > 0 ? `${m}m` : ""}`
            ).trim() || "N/A";
          })()
          : firstSegment.duration || "N/A";


        /* =========================
           FARES
        ========================= */

        if (flight.fares?.length > 0) {
          flight.fares.forEach(
            (fare, fareIndex) => {

              const isRemoved =
                removedShareFares.some(
                  (item) =>
                    item.flightIndex ===
                    selectedIndex &&
                    item.fareIndex ===
                    fareIndex
                );

              /*
               * Do not add removed fares
               */
              if (isRemoved) {
                return;
              }


              /* =========================
                 FARE TYPE
              ========================= */

              const fareType =
                fare.journeyFareInfos?.[0]?.type ||
                fare.fareName ||
                fare.fareType ||
                `Fare ${fareIndex + 1}`;


              /* =========================
                 REFUNDABLE
              ========================= */

              const priceType =
                fare.journeyFareInfos?.[0]
                  ?.isRefundable ??
                fare.isRefundable;


              const priceText =
                priceType === true
                  ? "Refundable"
                  : priceType === false
                    ? "Non Refundable"
                    : "-";


              /* =========================
                 ADD ROW
              ========================= */

              excelData.push({
                "Flight Name":
                  firstSegment.airLineName ||
                  "Unknown Airline",

                "Flight Number":
                  `${firstSegment.airLineCode || ""
                  }-${firstSegment.flightNumber || ""
                  }`,

                "Departure Time":
                  firstSegment.departDateTime
                    ? formatTime(
                      firstSegment.departDateTime
                    )
                    : "N/A",

                "Departure City":
                  firstSegment.departCityName ||
                  "",

                "Departure Airport":
                  firstSegment.departAirportCode ||
                  "",

                "Arrival Time":
                  lastSegment.arrivalDateTime
                    ? formatTime(
                      lastSegment.arrivalDateTime
                    )
                    : "N/A",

                "Arrival City":
                  lastSegment.arrivalCityName ||
                  flight.arrivalCityName ||
                  "",

                "Arrival Airport":
                  lastSegment.arrivalAirportCode ||
                  "",

                "Duration":
                  duration,

                "Fare Type":
                  fareType,

                "Amount":
                  Number(fare.totalFare || 0),

                "Price Type":
                  priceText,
              });
            }
          );
        } else {
          /*
           * Flight without fare
           */
          excelData.push({
            "Flight Name":
              firstSegment.airLineName ||
              "Unknown Airline",

            "Flight Number":
              `${firstSegment.airLineCode || ""
              }-${firstSegment.flightNumber || ""
              }`,

            "Departure Time":
              firstSegment.departDateTime
                ? formatTime(
                  firstSegment.departDateTime
                )
                : "N/A",

            "Departure City":
              firstSegment.departCityName ||
              "",

            "Departure Airport":
              firstSegment.departAirportCode ||
              "",

            "Arrival Time":
              lastSegment.arrivalDateTime
                ? formatTime(
                  lastSegment.arrivalDateTime
                )
                : "N/A",

            "Arrival City":
              lastSegment.arrivalCityName ||
              flight.arrivalCityName ||
              "",

            "Arrival Airport":
              lastSegment.arrivalAirportCode ||
              "",

            "Duration":
              duration,

            "Fare Type":
              "Fare not available",

            "Amount":
              "",

            "Price Type":
              "",
          });
        }
      });


      /* =========================
         CREATE WORKSHEET
      ========================= */

      const worksheet =
        XLSX.utils.json_to_sheet(
          excelData
        );


      /* =========================
         COLUMN WIDTHS
      ========================= */

      worksheet["!cols"] = [
        { wch: 25 }, // Flight Name
        { wch: 15 }, // Flight Number
        { wch: 18 }, // Departure Time
        { wch: 22 }, // Departure City
        { wch: 18 }, // Departure Airport
        { wch: 18 }, // Arrival Time
        { wch: 22 }, // Arrival City
        { wch: 18 }, // Arrival Airport
        { wch: 12 }, // Duration
        { wch: 20 }, // Fare Type
        { wch: 15 }, // Amount
        { wch: 20 }, // Price Type
      ];


      /* =========================
         CREATE WORKBOOK
      ========================= */

      const workbook =
        XLSX.utils.book_new();


      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Selected Flights"
      );


      /* =========================
         DOWNLOAD XLSX
      ========================= */

      XLSX.writeFile(
        workbook,
        "SelectedFlights.xlsx"
      );

    } catch (error) {
      console.error(
        "Download Excel Error:",
        error
      );

      alert(
        "Unable to download Excel file."
      );
    }
  };



  return (

    <div className="">
      <div className="row ruslt_sort mb-2 sticky">
        <div className="col-md-10 col-lg-10">

          <h3 className="destnation">
            {data.departureQuery?.split("(")[1]?.split(")")[0]}{" "}
            <i className="fa fa-arrow-right"></i>{" "}
            {data.arrivalQuery?.split("(")[1]?.split(")")[0]} || {" "}
            {[
              Number(data.adult) > 0 && `${data.adult} Adult`,
              Number(data.child) > 0 && `${data.child} Child`,
              Number(data.infant) > 0 && `${data.infant} Infant`
            ]
              .filter(Boolean)
              .join(", ")
            }

            <span style={{ color: "red" }}> || {formatDateForDisplay(data.onwardDate)}</span> || {requestBody.segments[0].preferredClass} ||

            {data?.fareType && (
              <span style={{ color: "#ff0000", marginLeft: "8px" }}>
                {data.fareType} ||
              </span>
            )}

            {flights.length > 0 && (
              <span style={{ color: "#ff0000", marginLeft: "10px" }}>flights : {flights.length}</span>
            )}

          </h3>
        </div>
        <div className="col-md-2 col-lg-2 text-end">
          <button
            className="modify_btn_sr"
            data-bs-toggle="modal"
            data-bs-target="#ModifyResult"
          >
            Modify Result <i className="fa fa-arrow-right"></i>
          </button>
        </div>
      </div>
      <div className="share_list mb-2">
        <div className="d-flex-reco">
          <div
            className={`fastest ${sortType === "CHEAPEST" ? "active" : ""}`}
            onClick={() => setSortType("CHEAPEST")}
            role="button"
            tabIndex={0}
          >
            <img src="/assets/images/rupee.png" alt="Cheapest" />
            <h4>Cheapest</h4>
          </div>

          <div
            className={`fastest ${sortType === "FASTEST" ? "active" : ""}`}
            onClick={() => setSortType("FASTEST")}
            role="button"
            tabIndex={0}
          >
            <img src="/assets/images/speed.png" alt="Fastest" />
            <h4>Fastest</h4>
          </div>

          <div
            className={`fastest ${sortType === "NONSTOP" ? "active" : ""}`}
            onClick={() => setSortType("NONSTOP")}
            role="button"
            tabIndex={0}
          >
            <img src="/assets/images/flight-blue.png" alt="Non Stop First" />
            <h4>Non Stop First</h4>
          </div>

          <div
            className={`fastest ${sortType === "DEPARTURE" ? "active" : ""}`}
            onClick={() => setSortType("DEPARTURE")}
            role="button"
            tabIndex={0}
          >
            <img src="/assets/images/flight-blue.png" alt="Departure" />
            <h4>Departure</h4>
          </div>

          <div
            className="ExportToExcl"
            onClick={() => ExportToExcel()}
            role="button"
            tabIndex={0}
          >
            <img src="/assets/images/excel.png" alt="Export To Excel" />
            <h4>Export To Excel</h4>
          </div>
          <div
            className="share_it"
            onClick={() => setshowAdSelct((prev) => !prev)}
            role="button"
            tabIndex={0}
          >
            <img src="/assets/images/share.png" alt="share flights" />
            <h4>Share IT</h4>
          </div>

          {showAdSelct && (
            <div className="shareit" data-bs-toggle="modal" data-bs-target="#shareFlights"> :
              {/* <img src="/assets/images/whatsapp.png" alt="share flights on whatsapp" /> */}
              {/* <img src="/assets/images/mail.png" alt="share flights on email" /> */}
              <img src="/assets/images/download-w.png" alt="share flights Details" />
              
            </div>
          )}
        </div>

      </div>



      {/* Loader */}


      {error && <p style={{ color: "red" }}>{error}</p>}
      {!loading && flights.length === 0 && !error && <p>No flights found.</p>}

      {/* Flights list */}
      {flights.length > 0 && (
        <>

          <div className="results">

            {sortedFlights.map((f, idx) => {
              const seg = f.segments?.[0] || {};

              const segments = f.segments || [];

              // Safety check
              const firstSeg = segments[0] || {};
              const lastSeg = segments[segments.length - 1] || {};

              // Flight Info
              const airLineCode =
                f.airLineCode || firstSeg.airLineCode || "";
              const airLineName =
                firstSeg.airLineName ||
                firstSeg.airlineName ||
                firstSeg.carrierName ||
                "Unknown Airline";
              const flightNumber =
                f.flightNumber || firstSeg.flightNumber || "";

              // Locations
              const origin =
                firstSeg.departAirportCode || f.departAirportCode || f.org || "";
              const destination =
                lastSeg.arrivalAirportCode || f.arrivalAirportCode || f.dest || "";

              // Timing (THIS IS THE MAIN FIX)
              const departTime =
                firstSeg.departDateTime || f.departDateTime || "";
              const arrivalTime =
                lastSeg.arrivalDateTime || f.arrivalDateTime || "";

              // Stops (correct for all cases)
              const stops =
                segments.length > 0 ? segments.length - 1 : 0;

              // Duration (correct end-to-end)
              const totalDuration =
                f.journeyDuration ||
                calcDuration(departTime, arrivalTime);

              // Fare Info
              const totalFare =
                Number(f.fares?.[0]?.totalFare || f.fare?.totalFare || 0);
              const isRefundable =
                f.fares?.[0]?.isRefundable ?? false;

              const policyStatus =
                selectedFareMap[f?.itemNo]?.policyStatus ||
                f?.fares?.[0]?.policyStatus ||
                f?.policyStatus ||
                "";
              return (
                <div key={idx} className="result_repeat mb-2">
                  <div className="row">
                    {/* Left Section */}
                    <div className="col-md-8 col-lg-8">
                      <div className="row">
                        <div className="col-md-4 col-lg-4">
                          <div className="row">
                            <div className="col-md-4 col-lg-4">
                              <div className="flight_img">
                                <div>
                                  <img
                                    src={`/assets/images/Flight_Images/${f.segments[0].airLineCode}.gif`}
                                    alt={f.segments[0].airLineName}
                                    width="50"
                                  />
                                </div>

                              </div>
                            </div>
                            <div className="col-md-8 col-lg-8">
                              <figure className="flight_sect">
                                <span className="airlineImage">
                                  {f?.segments?.[0]?.airLineName}
                                </span>

                                {f?.segments?.map((seg, i) => (
                                  <span className="multi_flgt" key={i}>
                                    {seg.airLineCode}-{seg.flightNumber}
                                    {i < f.segments.length - 1 && " || "}
                                  </span>
                                ))}
                              </figure>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-8 col-lg-8 border-left-right">
                          <div className="row">
                            <div className="col-md-4 col-lg-4 col-4">
                              <div className="timer">
                                <h4>{formatTime(departTime)}</h4>
                                <p>{origin}</p>
                              </div>
                            </div>
                            <div className="col-md-3 col-lg-3 col-3">
                              <div className="deruation">
                                <p>{totalDuration}</p>
                                <div className="bordr_top">
                                  <i className="fa fa-plane"></i>
                                </div>
                                <p className="stops">{stops} stop</p>
                              </div>
                            </div>
                            <div className="col-md-4 col-lg-4 offset-1 col-4">
                              <div className="timer">
                                <h4>{formatTime(arrivalTime)}</h4>
                                <p>{destination}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Right Price Section */}
                    <div className="col-md-4 col-lg-4">
                      <div className="price_view">
                        <div className="row">
                          <div className="col-md-7 col-lg-7">
                            <div className="flight_charge oneWy">
                              <i className="fa fa-inr"></i>
                              {
                                selectedFareMap[f?.itemNo]?.totalFare?.toLocaleString("en-IN") ||
                                f?.fares?.[0]?.totalFare?.toLocaleString("en-IN") ||
                                0
                              }

                              <p className="type_frs">
                                {
                                  selectedFareMap[f?.itemNo]?.journeyFareInfos?.[0]?.type ||
                                  f?.fares?.[0]?.journeyFareInfos?.[0]?.type ||
                                  "Regular"
                                }
                              </p>

                            </div>
                            <button
                              className="view_more"
                              onClick={() => handleViewMoreFare(f)}
                            >
                              View More Fare
                            </button>
                          </div>
                          <div className="col-md-5 col-lg-5">
                            {showAdSelct && (
                              <div className="form-check w-100 d-flex justify-content-center">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={selectedShareFlights.includes(idx)}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedShareFlights((prev) => [
                                        ...prev,
                                        idx,
                                      ]);
                                    } else {
                                      setSelectedShareFlights((prev) =>
                                        prev.filter((selectedIndex) => selectedIndex !== idx)
                                      );
                                    }
                                  }}
                                />
                              </div>
                            )}
                            <p
                              className={`policyStatus ${policyStatus === "WithinPolicy"
                                ? "text-success"
                                : policyStatus === "OutOfPolicy"
                                  ? "text-danger"
                                  : ""
                                }`}
                            >
                              {policyStatus && (
                                <img
                                  src={
                                    policyStatus === "WithinPolicy"
                                      ? "/assets/images/approved.png"
                                      : policyStatus === "OutOfPolicy"
                                        ? "/assets/images/cancelled.png"
                                        : ""
                                  }
                                  alt="status"
                                  style={{ marginRight: "6px" }}
                                />
                              )}

                              {policyStatus}
                            </p>

                            <button className="book_now_fly"
                              onClick={() => handleBookNow(f, 0)}
                              disabled={loadingFlightIndex === idx}
                            >
                              {loadingFlightIndex === idx ? "Checking Price..." : "Book Now"}
                            </button>
                            {/* <div className="In-Policy"> <img src="/assets/images/approved.png" /> In-Policy</div> */}
                            {/* <div className="Out-Policy"> <img src="/assets/images/cancelled.png" /> Out-Policy</div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    {f.segments.map((segment, index) => (
                      <div key={index}>

                      </div>
                    ))}
                    {/* Footer Info */}
                    <div className="col-md-12 col-lg-12">
                      <ul className="list_service">
                        <li>
                          <div className="d-flex">
                            <div className="equipmentType">
                              <i className="fa-solid fa-fan"></i>
                              <span>{f.segments[0].equipmentType}</span>
                            </div>

                            <div className="equipmentType">
                              <img
                                className="seats"
                                src="/assets/images/seat.png"
                                alt="seat"
                              />
                              <span>{f.segments[0].availableSeats} Seats</span>
                            </div>
                          </div>

                        </li>
                        <li className="refundable">


                          {isRefundable ? (
                            <span style={{ color: "green" }}><i className="fa fa-inr" style={{ color: "green" }}></i> Refundable</span>
                          ) : (
                            <span style={{ color: "red" }}><i className="fa fa-inr" style={{ color: "red" }}></i> Non-Refundable</span>
                          )}

                        </li>
                        {["TMC Operations", "TMC Manager"].some(role => roles?.includes(role)) && (
                          <li className="view_on">
                            <p class="policyStatus text-success">{f.supSource}</p>
                          </li>
                        )}

                        <li className="view_on">

                          <a
                            className="flight_details"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#FlightDetails"
                            //onClick={() => setSelectedFlight(f)}
                            onClick={() => {
                              setSelectedFlight(f);
                              setSelectedFare(f.fares?.[0]);
                            }}
                          >
                            <i className="fa fa-plane"></i> Flight Details
                          </a>
                        </li>
                      </ul>
                      {/* <p className="required_visa">
                          Dear, Don't need visa:{" "}
                          <span>{"Visa on Arrival"}</span>
                        </p> */}
                    </div>
                  </div>




                </div>

              );
            })}
          </div>
        </>
      )}
      {loading && <p className="text-center load"><span className="loader"></span></p>}

      <div className="offcanvas offcanvas-end" id="ViewMoreFare" tabIndex="-1" aria-labelledby="ViewMoreFareLabel">
        <div className="offcanvas-header">
          <h1 className="offcanvas-title" id="ViewMoreFareLabel">
            More Fare Options Available
          </h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>
              <div className="vie_fare d-flex align-items-center gap-3">
                <div className="from_to">
                  <img
                    alt={selectedFlight.segments?.[0]?.airLineName || "airline"}
                    src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`}
                  />
                </div>
                <div className="flight_time">
                  <span>
                    <strong>
                      {selectedFlight.segments?.[0]?.departCityName} ({selectedFlight.segments?.[0]?.departAirportCode}) →{" "}
                      {selectedFlight.arrivalCityName ||
                        selectedFlight.segments?.[selectedFlight.segments.length - 1]?.arrivalCityName}
                      (
                      {selectedFlight.segments?.[selectedFlight.segments.length - 1]?.arrivalAirportCode}
                      )
                    </strong>
                  </span>
                  <span>
                    <strong>{selectedFlight.segments?.[0]?.airLineName}</strong>
                  </span>

                  <span>
                    <strong>
                      {new Date(
                        selectedFlight.segments?.[0]?.departDateTime
                      ).toDateString()}
                    </strong>
                  </span>
                  <span>
                    Departure at:{" "}
                    <strong>{formatTime(selectedFlight.segments?.[0]?.departDateTime)}</strong>
                  </span>
                  <span>
                    Arrival at:{" "}
                    <strong>{formatTime(selectedFlight.segments?.[0]?.arrivalDateTime)}</strong>
                  </span>
                </div>
              </div>

              <div className="d-flex flex-wrap mt-3">
                {selectedFlight.fares?.length > 0 ? (
                  selectedFlight.fares.map((fare, index) => (
                    <div key={index} className="Select_new_fare repeat_section">
                      <h5>{fare?.journeyFareInfos[0]?.type}</h5>
                      <p
                        className={`policyStatus text-en ${fare?.policyStatus === "WithinPolicy"
                          ? "text-success"
                          : fare?.policyStatus === "OutOfPolicy"
                            ? "text-danger"
                            : ""
                          }`}
                      >
                        {fare?.policyStatus && (
                          <img
                            src={
                              fare.policyStatus === "WithinPolicy"
                                ? "/assets/images/approved.png"
                                : fare.policyStatus === "OutOfPolicy"
                                  ? "/assets/images/cancelled.png"
                                  : ""
                            }
                            alt="status"
                            style={{ marginRight: "6px" }}
                          />
                        )}

                        {fare.policyStatus}
                      </p>
                      <h3>
                        <i className="fa fa-inr"></i>{" "}
                        {fare.totalFare?.toLocaleString("en-IN")}
                      </h3>

                      <div className="riepet d-flex flex-wrap justify-content-between">

                        <div className="baggage">
                          <h4>
                            <i className="fa fa-suitcase-rolling"></i> Fare Inclusions
                          </h4>

                          <ul>
                            {fare.fareInclusions && fare.fareInclusions.length > 0 ? (
                              fare.fareInclusions.map((item, i) => (
                                <li key={i}> {item}</li>
                              ))
                            ) : (
                              <li>No fare inclusions available</li>
                            )}
                          </ul>
                        </div>
                      </div>

                      <div className="d-flex-btn d-flex justify-content-between align-items-center mt-2">
                        <p
                          className="refun"
                          style={{
                            color: fare.isRefundable ? "green" : "red",
                            fontWeight: "500",
                          }}
                        >
                          {fare.isRefundable ? "Refundable" : "Non Refundable"}
                        </p>
                        <p
                          className="faReRule"
                          data-bs-toggle="modal"
                          data-bs-target="#FareRuleModal"
                          onClick={() => {
                            setLoadFareRule(true);
                            setFareRuleIndex(index);
                          }}
                        >
                          Fare Rule
                        </p>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => {
                            setSelectedFare(fare);
                            setSelectedFareIndex(index); // <-- IMPORTANT
                          }}
                        >
                          Select
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No fare options available</p>
                )}
              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>

        {selectedFare && (
          <div className="total_amount border-top p-3">
            <p className="Grand">Grand Total <span style={{ color: 'red' }}>({selectedFare?.journeyFareInfos[0]?.type || ""})</span> </p>
            <h1>
              <i className="fa fa-inr"></i>{" "}
              {selectedFare?.totalFare?.toLocaleString("en-IN")}
            </h1>
            <button
              className="btn btn-primary"
              onClick={() => {
                if (!selectedFare) {
                  alert("Please select a fare");
                  return;
                }

                const updatedFlight = {
                  ...selectedFlight,
                  selectedFare: selectedFare
                };

                handleBookNow(updatedFlight, selectedFareIndex);
              }}
              data-bs-dismiss="offcanvas"
            >
              {loadingFlightIndex === selectedFareIndex ? "Checking ..." : "Book Now"}
            </button>
          </div>
        )}
      </div>

      <div className="offcanvas offcanvas-end" tabIndex="-1" id="FlightDetails" aria-labelledby="FlightDetailsLabel">
        <div className="offcanvas-header">
          <h1 className="offcanvas-title">Flight Details</h1>

          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => {
              setActiveTab("info");
              setLoadFareRuleTab(false);
            }}
          ></button>
        </div>

        <div className="offcanvas-body">
          {selectedFlight ? (
            <>
              <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">

                {/* Flight Info */}

                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "info" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_4"
                    onClick={() => setActiveTab("info")}
                  >
                    Flight Information
                  </a>
                </li>

                {/* Fare Rules */}
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "fare" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_5"
                    onClick={() => {
                      setActiveTab("fare");
                      if (!selectedFlight?.itemNo) return;
                      setLoadFareRuleTab(true);
                    }}
                  >
                    Fare Rules & Cancellation Change Rule
                  </a>
                </li>

                {/* Baggage */}
                <li className="nav-item">
                  <a
                    className={`nav-link ${activeTab === "baggage" ? "active" : ""}`}
                    data-bs-toggle="tab"
                    href="#kt_tab_pane_6"
                    onClick={() => setActiveTab("baggage")}
                  >
                    Baggage Information
                  </a>
                </li>



              </ul>

              <div className="tab-content" id="myTabContent">
                <div
                  className={`tab-pane fade ${activeTab === "info" ? "show active" : ""}`}
                  id="kt_tab_pane_4"
                >
                  <h3 className="destnation">
                    {selectedFlight.segments?.[0]?.departCityName} ({selectedFlight.segments?.[0]?.departAirportCode}) <i className="fa fa-arrow-right px-2"></i>

                    {selectedFlight.arrivalCityName ||
                      selectedFlight.segments?.[selectedFlight.segments.length - 1]?.arrivalCityName}
                    (
                    {selectedFlight.segments?.[selectedFlight.segments.length - 1]?.arrivalAirportCode}
                    )

                  </h3>
                  <ul className="rlst_flight_detls">
                    {/* <li>{selectedFlight.tripType === 1 ? "One Way" : "Round Trip"}</li> */}
                    <li>{selectedFlight.selClass}</li>
                    <li>{selectedFlight.adult + selectedFlight.child + selectedFlight.infant} Traveller(s)</li>
                    <li>{new Date(selectedFlight.segments?.[0]?.departDateTime).toDateString()}</li>
                  </ul>
                  <div className="d-flex flgt_dlts">
                    <div className="img_img_flight">
                      <img className="flight_i" src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                    </div>
                    <div className="text_img_t">
                      <h5>{new Date(selectedFlight.segments?.[0]?.departDateTime).toDateString()}</h5>
                      <p>{selectedFlight.segments?.[0]?.departCityName} ({selectedFlight.segments?.[0]?.departAirportCode}) <i className="fa fa-arrow-right px-2"></i>
                        {selectedFlight.arrivalCityName ||
                          selectedFlight.segments?.[selectedFlight.segments.length - 1]?.arrivalCityName}
                        (
                        {selectedFlight.segments?.[selectedFlight.segments.length - 1]?.arrivalAirportCode}
                        ) | {selectedFlight.segments?.[0]?.duration || "Duration N/A"} </p>
                    </div>
                  </div>
                  <div className="d-flex-v">
                    <div className="d-flex-v-f">
                      <h4>{formatTime(selectedFlight.segments?.[0]?.departDateTime)}</h4>
                    </div>
                    <div className="d-flex-v-m"><span className="zero"></span></div>
                    <div className="d-flex-v-l">
                      <h4>{selectedFlight.segments?.[0]?.departCityName} ({selectedFlight.segments?.[0]?.departAirportCode})</h4>
                      <p>  {selectedFlight.segments?.[0]?.departAirportName}
                        {selectedFlight.segments?.[0]?.departTerminal
                          ? `, Terminal ${selectedFlight.segments?.[0]?.departTerminal}`
                          : ""}</p>
                    </div>
                  </div>

                  <div className="d-flex-v time_to_frm">
                    <div className="d-flex-v-l m-autto">
                      {selectedFlight.segments?.map((seg, index) => {
                        const departDate = new Date(seg.departDateTime);
                        const arrivalDate = new Date(seg.arrivalDateTime);
                        const getDurationBetween = (fromTime, toTime) => {
                          const start = new Date(fromTime);
                          const end = new Date(toTime);

                          const diffMs = end - start;
                          if (diffMs <= 0) return "";

                          const minutes = Math.floor(diffMs / 60000);
                          const hrs = Math.floor(minutes / 60);
                          const mins = minutes % 60;

                          return `${hrs > 0 ? hrs + "h " : ""}${mins}m`;
                        };
                        const departTime = departDate.toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        });

                        const arrivalTime = arrivalDate.toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        });

                        const isLast = index === selectedFlight.segments.length - 1;
                        const nextSeg = selectedFlight.segments[index + 1];

                        const layoverDuration =
                          nextSeg &&
                          getDurationBetween(seg.arrivalDateTime, nextSeg.departDateTime);

                        return (
                          <div key={index}>
                            {/* SEGMENT */}
                            <div className="d-flex mb-3 align-items-center">
                              {/* DATE + TIME */}
                              <div className="d-flex-v-f m-autto me-3">
                                <h6>{departDate.toDateString()}</h6>
                                <p className="mb-0">
                                  {departTime} ➜ {arrivalTime}
                                </p>
                              </div>

                              <div className="d-flex-v-m fhty_rg">
                                <i className="fa fa-plane flights"></i>
                              </div>

                              {/* AIRLINE */}
                              <div className="d-flex">
                                <div className="img_flt">
                                  <img
                                    className="flight_i"
                                    src={`/assets/images/Flight_Images/${seg.airLineCode}.gif`}
                                    alt={seg.airLineName}
                                  />
                                </div>

                                <div className="flt_name ms-2">
                                  {seg.airLineName} – {seg.airLineCode}-{seg.flightNumber}
                                </div>
                              </div>
                            </div>

                            {/* STOP / LAYOVER INFO */}
                            {!isLast && (
                              <div className="layover-info">
                                <p className="mb-0">
                                  <strong>Stop:</strong>{" "}
                                  {seg.arrivalCity ||
                                    seg.arrivalAirportName ||
                                    seg.destination}
                                </p>
                                <h4 className="text-red">
                                  Layover : {layoverDuration}
                                </h4>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div className="d-flex-v">
                    {(() => {
                      const segments = selectedFlight.segments || [];
                      const lastSeg = segments[segments.length - 1] || {};

                      return (
                        <>
                          <div className="d-flex-v-f">
                            <h4>{formatTime(lastSeg.arrivalDateTime)}</h4>
                          </div>

                          <div className="d-flex-v-m">
                            <span className="zero"></span>
                          </div>

                          <div className="d-flex-v-l">
                            <h4> {(selectedFlight.arrivalCityName || lastSeg?.arrivalCityName)}
                              ({selectedFlight.segments?.[selectedFlight.segments.length - 1]?.arrivalAirportCode})</h4>

                            <p>
                              {lastSeg.arrivalAirportName}
                              {lastSeg.arrivalTerminal
                                ? `, Terminal ${lastSeg.arrivalTerminal}`
                                : ""}
                            </p>
                          </div>
                        </>
                      );
                    })()}
                  </div>


                </div>
                <div className="tab-pane fade" id="kt_tab_pane_5" role="tabpanel">
                  <div className="row">
                    <div className="col-md-12">
                      <FareRule
                        load={loadFareRuleTab}
                        clientCode={requestBody?.clientCode}
                        keyValue={requestBody?.key}
                        supplierCode={requestBody?.supplierCode}
                        departAirportCode={requestBody?.origin}
                        arrivalAirportCode={requestBody?.destination}
                        resultIndex={selectedFlight?.itemNo}
                        sessionID={requestBody?.sessionID}
                        flight={selectedFlight}
                        index={0}
                      />
                    </div>
                  </div>
                </div>
                <div className="tab-pane fade" id="kt_tab_pane_6" role="tabpanel">
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <th>Airline</th>
                        <th>Check-in Baggage</th>
                        <th>Cabin Baggage</th>
                      </tr>
                      <tr>
                        <td>
                          <img className="flight_name" src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                          <p className="plane_name">{selectedFlight.segments?.[0]?.airLineName}</p>
                          <p className="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>

                        </td>
                        <td>15kgs</td>
                        <td>7kgs</td>
                      </tr>
                      <tr>
                        <td>
                          <img className="flight_name" src={`/assets/images/Flight_Images/${selectedFlight.segments?.[0]?.airLineCode}.gif`} alt={selectedFlight.segments?.[0]?.airLineName} />
                          <p className="plane_name">{selectedFlight.segments?.[0]?.airLineName}</p>
                          <p className="code_plne">{selectedFlight.segments?.[0]?.airLineCode}-
                            {selectedFlight.segments?.[0]?.flightNumber}</p>
                        </td>
                        <td>15kgs</td>
                        <td>7kgs</td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <div className="termsbagg">
                            <ul>
                              <li>Baggage information mentioned above is obtained from airline's reservation system, Trans India Technologiess does not guarantee the accuracy of this information.</li>
                              <li>The baggage allowance may vary according to stop-overs, connecting flights. changes in airline rules. etc.</li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>

              <div className="total_amount">
                <p className="Grand">Grand Total</p>
                <h1>
                  <i className="fa fa-inr"></i>{" "}
                  {Number(selectedFlight.fares?.[0]?.totalFare || 0).toLocaleString()}
                </h1>
                {/* <button className="btn btn-primary">Book Now</button> */}
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    if (!selectedFare) {
                      alert("Please select a fare");
                      return;
                    }

                    const updatedFlight = {
                      ...selectedFlight,
                      selectedFare: selectedFare   // ✅ THIS WAS MISSING
                    };

                    handleBookNow(updatedFlight, 0);
                  }}
                >
                  {loadingFlightIndex !== null && loadingFlightIndex === selectedFareIndex
                    ? "CheckingPrice..."
                    : "Book Now"}
                </button>

              </div>
            </>
          ) : (
            <p>No flight selected</p>
          )}
        </div>
      </div>

      {/* Fare Rule For Perticular Fare */}

      {/* Fare Rule For Perticular Fare */}
      <div className="modal fade" id="FareRuleModal" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h4 className="modal-title">Fare Rule</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                onClick={() => setLoadFareRule(false)}
              ></button>
            </div>

            <div className="modal-body">
              <div className="row">
                {/* {selectedFlight && loadFareRule && ( */}
                {selectedFlight && loadFareRule && fareRuleIndex !== null && (
                  <>
                    <div className="col-md-12">
                      <FareRule
                        load={loadFareRule}
                        clientCode={requestBody?.clientCode}
                        keyValue={requestBody?.key}
                        supplierCode={requestBody?.supplierCode}
                        departAirportCode={requestBody?.origin}
                        arrivalAirportCode={requestBody?.destination}
                        resultIndex={selectedFlight?.itemNo}
                        sessionID={requestBody?.sessionID}
                        flight={selectedFlight}
                        index={fareRuleIndex}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* select flight to share start */}

      <div className="modal fade" id="shareFlights" tabIndex="-1">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">

            <div className="modal-header">
              <h4 className="modal-title">
                Selected Flight to Share
              </h4>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">

              {selectedShareFlights.length === 0 ? (
                <div className="text-center py-4">
                  <p className="mb-0">
                    No flight selected. Please Select At Least one.
                  </p>
                </div>
              ) : (
                <div className="table-responsive">

                  <table className="table text-center align-middle table-bordered">

                    <thead
                      style={{
                        background: "#110942",
                        color: "#fff",
                      }}
                    >
                      <tr>

                        <th></th>

                        <th style={{ color: "#fff" }}>
                          Flight Name
                        </th>

                        <th style={{ color: "#fff" }}>
                          Departure Time
                        </th>

                        <th style={{ color: "#fff" }}>
                          Arrival Time
                        </th>
                        <th style={{ color: "#fff" }}>
                          Duration
                        </th>
                        <th style={{ color: "#fff" }}> Stops / Via </th>

                        <th style={{ color: "#fff" }}>
                          Fares
                        </th>

                      </tr>
                    </thead>

                    <tbody>

                      {selectedShareFlights.map(
                        (selectedIndex) => {

                          /* Get actual flight */
                          const flight =
                            sortedFlights[selectedIndex];

                          /* Safety check */
                          if (!flight) {
                            return null;
                          }

                          const segments =
                            flight.segments || [];

                          const firstSegment =
                            segments[0] || {};

                          const lastSegment =
                            segments[
                            segments.length - 1
                            ] || {};
                          const stopCount = Math.max(segments.length - 1, 0); const viaCities = segments.slice(0, -1).map((segment) => segment.arrivalCityName || segment.arrivalCity || segment.arrivalAirportName || segment.destination || "").filter(Boolean);

                          return (
                            <tr
                              key={selectedIndex}
                            >

                              {/* =========================
                            REMOVE FLIGHT
                        ========================== */}

                              <td>

                                <button
                                  type="button"
                                  className="btn p-0"
                                  title="Remove flight"
                                  onClick={() => {

                                    setSelectedShareFlights(
                                      (prev) =>
                                        prev.filter(
                                          (index) =>
                                            index !==
                                            selectedIndex
                                        )
                                    );

                                    /* Also remove fare selections
                                       belonging to this flight */

                                    setRemovedShareFares(
                                      (prev) =>
                                        prev.filter(
                                          (item) =>
                                            item.flightIndex !==
                                            selectedIndex
                                        )
                                    );
                                  }}
                                >

                                  <img
                                    src="/assets/images/delete.png"
                                    alt="Remove flight"
                                    width={20}
                                  />

                                </button>

                              </td>


                              {/* =========================
                            FLIGHT NAME
                        ========================== */}

                              <td>

                                <div className="d-flex align-items-center justify-content-center gap-2">

                                  <img
                                    src={`/assets/images/Flight_Images/${firstSegment.airLineCode}.gif`}
                                    alt={
                                      firstSegment.airLineName ||
                                      ""
                                    }
                                    className="flight_i"
                                  />

                                  <span>

                                    {firstSegment.airLineName ||
                                      "Unknown Airline"}{" "}

                                    {firstSegment.airLineCode ||
                                      ""}

                                    -

                                    {firstSegment.flightNumber ||
                                      ""}

                                  </span>

                                </div>

                              </td>


                              {/* =========================
                            DEPARTURE
                        ========================== */}

                              <td>

                                <strong>

                                  {firstSegment.departDateTime
                                    ? formatTime(
                                      firstSegment.departDateTime
                                    )
                                    : "N/A"}

                                </strong>

                                <br />

                                {firstSegment.departCityName ||
                                  ""}

                                {firstSegment.departAirportCode
                                  ? ` (${firstSegment.departAirportCode})`
                                  : ""}

                              </td>


                              {/* =========================
                            ARRIVAL
                        ========================== */}

                              <td>

                                <strong>

                                  {lastSegment.arrivalDateTime
                                    ? formatTime(
                                      lastSegment.arrivalDateTime
                                    )
                                    : "N/A"}

                                </strong>

                                <br />

                                {lastSegment.arrivalCityName ||
                                  flight.arrivalCityName ||
                                  ""}

                                {lastSegment.arrivalAirportCode
                                  ? ` (${lastSegment.arrivalAirportCode})`
                                  : ""}

                              </td>


                              {/* =========================
                            DURATION
                        ========================== */}

                              <td>

                                {flight.totalDuration
                                  ? (() => {

                                    const [
                                      hours,
                                      minutes,
                                    ] =
                                      String(
                                        flight.totalDuration
                                      ).split(":");

                                    const h =
                                      parseInt(
                                        hours || 0,
                                        10
                                      );

                                    const m =
                                      parseInt(
                                        minutes || 0,
                                        10
                                      );

                                    return (
                                      `${h > 0
                                        ? `${h}h `
                                        : ""
                                      }${m > 0
                                        ? `${m}m`
                                        : ""
                                      }`
                                    ).trim() ||
                                      "N/A";

                                  })()
                                  : firstSegment.duration ||
                                  "N/A"}

                              </td>

                              <td> {stopCount === 0 ? (<strong> Non-stop </strong>) : (<> <strong> {stopCount}{" "} {stopCount === 1 ? "Stop" : "Stops"} </strong> {viaCities.length > 0 && (<> <br /> <span> via{" "} {viaCities.join(", ")} </span> </>)} </>)} </td>
                              {/* =========================
                            FARES
                        ========================== */}

                              <td>

                                {flight.fares?.length > 0 ? (

                                  <table className="table table-bordered table-sm mb-0">

                                    <thead>

                                      <tr>

                                        <th>
                                          Fare Type
                                        </th>

                                        <th>
                                          Amount
                                        </th>

                                        <th>
                                          Price Type
                                        </th>

                                        <th></th>

                                      </tr>

                                    </thead>


                                    <tbody>

                                      {flight.fares.map(
                                        (
                                          fare,
                                          fareIndex
                                        ) => {

                                          /* Check removed fare */

                                          const isRemoved =
                                            removedShareFares.some(
                                              (item) =>
                                                item.flightIndex ===
                                                selectedIndex &&
                                                item.fareIndex ===
                                                fareIndex
                                            );

                                          /* Don't display removed fare */

                                          if (
                                            isRemoved
                                          ) {
                                            return null;
                                          }


                                          /* Fare Type */

                                          const fareType =
                                            fare
                                              .journeyFareInfos?.[0]
                                              ?.type ||

                                            fare.fareName ||

                                            fare.fareType ||

                                            `Fare ${fareIndex + 1
                                            }`;


                                          /* Refundable */

                                          const priceType =
                                            fare
                                              .journeyFareInfos?.[0]
                                              ?.isRefundable ??
                                            fare.isRefundable;


                                          return (
                                            <tr
                                              key={
                                                fareIndex
                                              }
                                            >

                                              {/* Fare Type */}

                                              <td>
                                                {fareType}
                                              </td>


                                              {/* Amount */}

                                              <td>

                                                <i className="fa fa-inr"></i>{" "}

                                                {Number(
                                                  fare.totalFare ||
                                                  0
                                                ).toLocaleString(
                                                  "en-IN"
                                                )}

                                              </td>


                                              {/* Price Type */}

                                              <td>

                                                <p
                                                  className="refun mb-0"
                                                  style={{
                                                    color:
                                                      priceType ===
                                                        true
                                                        ? "green"
                                                        : priceType ===
                                                          false
                                                          ? "red"
                                                          : "inherit",

                                                    fontWeight:
                                                      "500",
                                                  }}
                                                >

                                                  {priceType ===
                                                    true
                                                    ? "Refundable"
                                                    : priceType ===
                                                      false
                                                      ? "Non Refundable"
                                                      : "-"}

                                                </p>

                                              </td>


                                              {/* Remove Price */}

                                              <td className="text-center">

                                                <button
                                                  type="button"
                                                  className="btn p-0"
                                                  title="Remove price"
                                                  onClick={() => {

                                                    setRemovedShareFares(
                                                      (
                                                        prev
                                                      ) => {

                                                        /* Prevent duplicate entries */

                                                        const alreadyRemoved =
                                                          prev.some(
                                                            (
                                                              item
                                                            ) =>
                                                              item.flightIndex ===
                                                              selectedIndex &&
                                                              item.fareIndex ===
                                                              fareIndex
                                                          );

                                                        if (
                                                          alreadyRemoved
                                                        ) {
                                                          return prev;
                                                        }

                                                        return [
                                                          ...prev,
                                                          {
                                                            flightIndex:
                                                              selectedIndex,

                                                            fareIndex:
                                                              fareIndex,
                                                          },
                                                        ];
                                                      }
                                                    );

                                                  }}
                                                >

                                                  <img
                                                    src="/assets/images/cancelled.png"
                                                    alt="Remove price"
                                                    width={16}
                                                  />

                                                </button>

                                              </td>

                                            </tr>
                                          );

                                        }
                                      )}

                                    </tbody>

                                  </table>

                                ) : (

                                  <span>
                                    Fare not available
                                  </span>

                                )}

                              </td>

                            </tr>
                          );
                        }
                      )}

                    </tbody>

                  </table>

                </div>
              )}

            </div>


            {/* =========================
          FOOTER
      ========================== */}

            <div className="modal-footer">


              <button
                type="button"
                className="btn btn-primary"
                disabled={
                  selectedShareFlights.length === 0
                }
              >

                Share To{" "}

                <img
                  src="/assets/images/whatsapp.png"
                  alt="Share flights on WhatsApp"
                  width={20}
                />

              </button>

              <button
                type="button"
                className="btn btn-primary"
                disabled={
                  selectedShareFlights.length === 0
                }
                onClick={handleCopyHTML}
              >

                Copy{" "}

                <img
                  src="/assets/images/copy.png"
                  alt="Copy HTML"
                  width={20}
                />

              </button>


              {/* =========================
            DOWNLOAD HTML
        ========================== */}

              <button
                type="button"
                className="btn btn-primary"
                disabled={selectedShareFlights.length === 0}
                onClick={handleDownloadExcel}
              >
                Download{" "}
                <img
                  src="/assets/images/download-w.png"
                  alt="Download Excel"
                  width={20}
                />
              </button>

            </div>

          </div>
        </div>
      </div>
      {/* select flight to share End */}

    </div>
  );
};

export default ResultHtml;
